import throttle from 'lodash/throttle';

const eventCtas = document.querySelectorAll('[data-js-event-cta]');

const NAVBAR_HEIGHT = 68;

if (eventCtas.length > 0) {
    const show = () => {
        document.body.classList.add('event-cta-visible');
    };

    const hide = () => {
        document.body.classList.remove('event-cta-visible');
    };

    const breakpoint = window.matchMedia('(min-width: 1024px)');

    const getScrollThreshold = () => {
        return breakpoint.matches ? window.innerHeight * 0.85 - NAVBAR_HEIGHT : window.innerHeight - NAVBAR_HEIGHT;
    };

    const setVisibility = () => {
        const shouldShow = window.scrollY > getScrollThreshold();

        if (shouldShow) {
            show();
        } else {
            hide();
        }
    };

    const handleScroll = throttle(setVisibility, 100);

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll);

    if (breakpoint.addEventListener) {
        breakpoint.addEventListener('change', handleScroll);
    } else if (breakpoint.addListener) {
        breakpoint.addListener(handleScroll);
    }

    setVisibility();
}
